<template>
  <div
    v-if="currentRouteName !== 'line-user-account'"
    class="mr-50 cursor-pointer"
    @click="onClick"
  >
    <feather-icon
      size="20"
      icon="UserIcon"
      style="margin-top: -3px;"
    />
    <span class="ml-50 text-body">{{ $t('User Account') }}</span>
  </div>
</template>

<script>
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'

export default {
  components: {
    FeatherIcon,
  },
  computed: {
    currentRouteName() {
      return this.$route.name
    },
  },
  methods: {
    onClick() {
      this.$router.push({ name: 'line-user-account', params: { prevRoute: '' } })
    },
  },
}
</script>

<style>

</style>
